import React, { Component } from "react";
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import axios from "axios";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // This only needs to be imported
import { configuration } from "../../../appConfig";
import "./PhotoApp.css";
import PhotoGalleryImageEditor from "./PhotoGalleryImageEditor";
import moment from "moment";
import "./PhotoApp.css";
import { Card } from 'reactstrap'
import { token } from "../../../appTokenConfig";
import { reportAuthorized } from "../../../redux/actions/reportAuthorized";
const dashboardErrorLogo = require("../../../assets/img/brand/dashboard-error-logo.png");
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');
const arrayForApplyTimeStamp = ['vehicleRegistrationDocument', 'QRCodeFrontPage', 'QRCodeOnTheBack'];

export class PhotoApp extends Component {
  constructor(props) {
    super(props);
    this.webcamRef = React.createRef(null);
    this.ExtraImage = React.createRef(null);
    this.UploadImages = React.createRef(null);
    this.state = {
      allExtraDocumentImageArr: [
        "NC-NoteOfFinding",
        "CI-IdentityCard",
        "RegistrationCertificate",
        "RepairEstimate",
        "ServiceContract",
        "LeasingAuthorization",
        "CompanyAuthorization",
        "CascoPolicy",
        "DamageDeclaration",
        "DrivingLicense",
        "OtherDocuments",
      ],
      allExtraImageArr: [
        "vehicleRegistrationDocument",
        // "Dashboard/Mileage",
        "Mileage",
        "chassisNumber",
        "QRCodeFrontPage",
        "QRCodeOnTheBack",
        "paymentDetails",
        "frontLeft",
        "frontRight",
        "backLeft",
        "backRight",
        "Roof",
        // "pre-Damage-1",
        // "pre-Damage-2",
        // "pre-Damage-3",
        // "pre-Damage-4",
      ],
      allExtraImageSwissArr: [
        "RightVehicleidentificationpageWithoutcontrolshield",
        "Front",
        "Teil",
        "Trunk-extra",
        "1wheel",
        "Enginecompartment",
        "WholeDashboard",
        "Frontseat",
        "Seatrear",
        "BeltsBeltTighteners",
        "InstrumentdisplaywithKMandRunningengine",
        "ServicebookletCarkey",
        "PurchaseInvoiceReceipt",
        "Leasingcontract",
        "Investments",
        "Invoice",
        "additionalimage-1",
        "additionalimage-2",
      ],
      otherExtraImages: [
        // "extraImage-1",
        // "extraImage-2",
        "extraImage-x",
      ],
      otherDocumentImages: [
        "document-x",
      ],
      otherBrowseImages: [
        "browse-x",
      ],
      documentImgArray: [],
      preDamageImagesArr: [],
      damageExtraImages: [],
      isExtraImageModalOpen: false,
      imageSrc: "",
      captureImageName: "",
      words: {},
      lang: "",
      extraImages: [],
      extraDocumentImages: [],
      isLightBoxOpen: false,
      showExtraImage: false,
      showExtraImage1111: false,
      imageName: "",
      videoConstraints: {},
      isEditor: false,
      isEditLoading: false,
      isDeleteLoading: false,
      showSearchResult: null,
      imagesModalCurrentSourceIndex: 0,
      extraImageNameArr: [],
      extraImageNameArr_1: [],
      extraImageNameArr_2: [],
      imagesArr: [],
      allOtherExtraImages: [],
      allOtherExtraImages_bulkImagesArr: [],
      isPreDamageImageLightBoxOpen: false,
      isRotateLoading: false,
      loading: false,
      Rotateimage: [],
      image: "",
      mergearr: false,
      arr: [],
      allnewExtraImages: false,
      isAnyOneImageUploaded: false,
      newArr: [],
      newArr_totalloss: [],
      bulkImagesArr: [],
      uniqueImageSuffix: Date.now(),
      updatedImages: {
        vehicleRegistrationDocument: Date.now(),
        QRCodeFrontPage: Date.now(),
        QRCodeOnTheBack: Date.now()
      },
      isUploadModalOpen: false,
      extraImgRadioValue: "1",
      uploadPartName: "damage",
      setOrderId: '',
      setActualVin: '',
      base64Images: [],
    };
  }

  componentDidMount = () => {
    this.getAllExtraImages();
    this.getLang();
    this.getData();
  };

  getLang = async () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  getIndex = async () => {
    const { imageName, extraImageNameArr, isLightBoxOpen, arr } = this.state;
    arr.map((image, i) => {
      let arr = image ? image.split('.')[0] : "";
      if (arr === imageName) {
        this.setState({
          imagesModalCurrentSourceIndex: i,
        },
          () => this.setState({
            isLightBoxOpen: !isLightBoxOpen,
          })
        );
      };
    });
  }

  handleToggle = (name) => {
    console.log(name);
    
    const { allExtraDocumentImageArr } = this.state
    const { isOpenImage } = this.props;
    const imageName = name.includes("/") ? name.split("/")[1] : name;
    const isExtraDocumentImage = allExtraDocumentImageArr.includes(name)

    if (isOpenImage) {
      const callback = () => this.getIndex();

      if (name.includes("extraImage")) {
        if (this.otherImageExistOrNot1(name, true)) {
          this.setState({ imageName, captureImageName: imageName }, callback);
        }
      } else if (name.includes("damage")) {
        if (this.damageImgExistOrNot(name, true)) {
          this.setState({ imageName, captureImageName: imageName }, callback);
        }
      } else if (name.includes("document")) {
        if (this.documentImageExistOrNot(name, true)) {
          this.setState({ imageName, captureImageName: imageName }, callback);
        }
      } else if (name.includes("browse")) {
        if (this.browseImageExistOrNot(name, true)) {
          this.setState({ imageName, captureImageName: imageName }, callback);
        }
      } else if (isExtraDocumentImage) {
        if (this.extraDocumentImageExistOrNot(name, true)) {
          this.setState({ imageName, captureImageName: imageName }, callback);
        }
      } else {
        if (this.imageExistOrNot(name, true)) {
          this.setState({ imageName, captureImageName: imageName }, callback);
        }
      }
    } else {
      this.setState({ imageSrc: "", captureImageName: name });

      if (name.includes("extraImage")) {
        if (!this.otherImageExistOrNot1(name, true)) {
          if (this.state.authorized) {
            Toast.fire({
              type: "error",
              title: this.lang("ThisVINisAuthorized"),
            });
            return
          }
          this.refs.ExtraImage.click();
        } else {
          this.setState({ imageName }, this.getIndex);
        }
      } else if (name.includes("damage")) {
        if (!this.damageImgExistOrNot(name, true)) {
          if (this.state.authorized) {
            Toast.fire({
              type: "error",
              title: this.lang("ThisVINisAuthorized"),
            });
            return
          }
          this.refs.ExtraImage.click();
        } else {
          this.setState({ imageName }, this.getIndex);
        }
      } else if (isExtraDocumentImage) {
        if (!this.extraDocumentImageExistOrNot(name, true)) {
          if (this.state.authorized) {
            Toast.fire({
              type: "error",
              title: this.lang("ThisVINisAuthorized"),
            });
            return
          }
          this.refs.ExtraImage.click();
        } else {
          this.setState({ imageName }, this.getIndex);
        }
      } else if (name.includes("document")) {
        if (!this.documentImageExistOrNot(name, true)) {
          if (this.state.authorized) {
            Toast.fire({
              type: "error",
              title: this.lang("ThisVINisAuthorized"),
            });
            return
          }
          this.refs.ExtraImage.click();
        } else {
          this.setState({ imageName }, this.getIndex);
        }
      } else if (name.includes("browse")) {
        if (!this.browseImageExistOrNot(name, true)) {
          if (this.state.authorized) {
            Toast.fire({
              type: "error",
              title: this.lang("ThisVINisAuthorized"),
            });
            return
          }
          this.refs.UploadImages.click();
        } else {
          this.setState({ imageName }, this.getIndex);
        }
      } else {
        if (!this.imageExistOrNot(name, true)) {
          if (this.state.authorized) {
            Toast.fire({
              type: "error",
              title: this.lang("ThisVINisAuthorized"),
            });
            return
          }
          this.refs.ExtraImage.click();
        } else {
          this.setState({ imageName }, this.getIndex);
        }
      }
    }
  };
  capture = async (e) => {
    const { files } = e.target;
    const base64 = await this.getBase644(files[0]);
    this.setState({
      imageSrc: base64,
    },
      () => {
        this.uploadImage();
      }
    );
  };
  captureBrowseImages = async (e) => {
    const { files } = e.target;
    const base64Images = [];

    for (let i = 0; i < files.length; i++) {
      const base64 = await this.getBase644(files[i]);
      base64Images.push(base64);
    }

    this.setState({
      base64Images: base64Images,
    },()=>{
      this.uploadMultipleImages();
    });
  };

  uploadBase64 = (base64image) => {
    const { captureImageName } = this.state;
    const { vin } = this.props;
    let captureDate = moment().utc(true).format(`DD-MM-YYYY hh:mm`);
    const url = configuration.uploadExtraImagesNew;
    let payload = {
      img: base64image.replace("jpeg", "jpg"),
      vin: vin || localStorage.getItem("selectedFile"),
      partnerId: localStorage.getItem("partnerId"),
      partName: captureImageName.includes("/") ? captureImageName.split("/")[1] : captureImageName,
      captureDate: captureDate
    };
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status === 200) {
          this.getAllExtraImages();
          // this.props.getPhotoAppExtraImages();
          Toast.fire({
            type: "success",
            title: "Image upload successfully!",
          });
          this.setState({
            // isLightBoxOpen: false,
            isLightBoxOpen: true,
          });
        } else if (res.data.status === 500) {
          Toast.fire({
            type: "error",
            title: "Internal server error!",
          });
        } else {
          Toast.fire({
            type: "error",
            title: "Something went wrong!",
          });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      })
      .finally(() => {
        this.setState({
          imageSrc: "",
          // isLightBoxOpen: false,
          isLightBoxOpen: true,
        })
        this.refs.ExtraImage.value = ""
      });
  }

  getBase644 = async (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  };

  uploadImage = () => {
    this.setState({
      loading: true,
    })
    const { imageSrc, captureImageName, allOtherExtraImages, damageExtraImages, otherExtraImages, otherDocumentImages } = this.state;
    const { vin } = this.props;
    // let utcHours = moment().utc(true).toString().split("GMT")[1].slice(0,3) + ':' + moment().toString().split("GMT")[1].slice(3,5);
    let captureDate = moment().utc(true).format(`DD-MM-YYYY hh:mm`);
    let filterDamageArray = damageExtraImages.reverse().filter((name) => {
      return name.includes(captureImageName);
    });
    let reverseOtherExtraImg = [...otherExtraImages].reverse();
    let reverseDocumentImg = [...otherDocumentImages].reverse();

    let otherStringValue;
    if (reverseOtherExtraImg.length > 1) {
      const splitValue =
        otherExtraImages[otherExtraImages.length - 2].split("-");
      const parseValue = parseInt(splitValue[1]) + 1;
      otherStringValue = JSON.stringify(parseValue);

    }
    let documentStringValue;
    if (reverseDocumentImg.length > 1) {
      const splitDocValue =
        otherDocumentImages[otherDocumentImages.length - 2].split("-");
      const parseDocValue = parseInt(splitDocValue[1]) + 1;
      documentStringValue = JSON.stringify(parseDocValue);
    }
    let stringValue;
    if (filterDamageArray.length > 0) {
      const splitValue =
        filterDamageArray[filterDamageArray.length - 1].split("-");
      const parseValue = parseInt(splitValue[2]) + 1;
      stringValue = JSON.stringify(parseValue);

    }



    const url = configuration.uploadExtraImages;
    let payload = {
      img: imageSrc,
      vin: vin || localStorage.getItem("selectedFile"),
      part_type: this.state.extraImgRadioValue,
      partnerId: localStorage.getItem("partnerId"),
      partName: captureImageName === "extraImage-x"
        ? otherExtraImages[0] !== "extraImage-x"
          ? `extraImage-${otherStringValue}`
          : `extraImage-${otherExtraImages.length}`
        : captureImageName === "damage"
          ? filterDamageArray.length > 0
            ? `pre-damage-${stringValue}`
            : `pre-damage-${filterDamageArray.length + 1}`
          : captureImageName === "document-x"
            ? otherDocumentImages[0] !== "document-x"
              ? `document-${documentStringValue}`
              : `document-${otherDocumentImages.length}`
            : captureImageName.includes("/")
              ? captureImageName.split("/")[1]
              : captureImageName,
      captureDate: captureDate
    };

    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status === 200) {
          this.getAllExtraImages(captureImageName);
          // if(this.props.hasOwnProperty('getPhotoAppExtraImages')) {
          //   this.props.getPhotoAppExtraImages();
          // }
          Toast.fire({
            type: "success",
            title: "Image upload successfully!",
          });
          this.setState({
            // isLightBoxOpen: false,
            isLightBoxOpen: true,
            isUploadModalOpen: false,
            loading: false
          });
        } else if (res.data.status === 500) {
          Toast.fire({
            type: "error",
            title: "Internal server error!",
          });
          this.setState({
            loading: false,
            isUploadModalOpen: false,
          })
        } else {
          Toast.fire({
            type: "error",
            title: "Something went wrong!",
          });
          this.setState({
            loading: false,
            isUploadModalOpen: false,
          })
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
        this.setState({
          loading: false,
          isUploadModalOpen: false,
        })
      })
      .finally(() => {
        this.setState({
          imageSrc: "",
          isLightBoxOpen: false,
          isUploadModalOpen: false,
        })
        this.refs.ExtraImage.value = ""
      });
  };
  uploadMultipleImages = async () => {
    this.setState({
      loading: true,
    })
    const { otherBrowseImages, captureImageName, base64Images} = this.state;
    const { vin } = this.props;
  
    if (!base64Images || base64Images.length === 0) {
      this.setState({ loading: false });
      return;
    }
  
    const uploadExtraImagesUrl = configuration.uploadExtraImages;
    let captureDate = moment().utc(true).format('DD-MM-YYYY hh:mm');
  
    let lastBrowseNumber = 0;
    const browseImageNumbers = otherBrowseImages
      .filter((img) => img !== "browse-x")
      .map((img) => {
        const splitValue = img.split("-");
        return parseInt(splitValue[1], 10);
      })
      .filter((num) => !isNaN(num));
  
    if (browseImageNumbers.length > 0) {
      lastBrowseNumber = Math.max(...browseImageNumbers);
    }
  
    try {
      await Promise.all(
        base64Images.map((base64, index) => {
          const newBrowseNumber = lastBrowseNumber + index + 1;
  
          let payload = {
            img: base64,
            vin: vin || localStorage.getItem("selectedFile"),
            part_type: this.state.extraImgRadioValue,
            partnerId: localStorage.getItem("partnerId"),
            partName: captureImageName === "browse-x" ? `browse-${newBrowseNumber}` : captureImageName,
            captureDate: captureDate,
          };
  
          var config = {
            onUploadProgress: (progressEvent) => {
              var percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              this.setState({ uploadPercent: percentCompleted });
            },
          };
  
          return axios.post(uploadExtraImagesUrl, payload, config);
        })
      );
  
      await this.getAllExtraImages();
      this.setState({
            loading: false
      });
      Toast.fire({
        type: "success",
        title: "Image upload successfully!",
      });
  
    } catch (error) {
      this.setState({ loading: false });
      console.error("Error uploading images:", error);
    }
  };

  getAllExtraImages = (retakePartName) => {
    let partnerId = localStorage.getItem("partnerId");
    const { vin } = this.props;
    const { allExtraDocumentImageArr } = this.state;
    const selectedVIN = vin ? vin : localStorage.getItem("selectedFile");
    const url = `${configuration.getExtraImages}?partnerId=${partnerId}&vin=${selectedVIN}&partName=yes`;
    axios
      .get(url)
      .then((res) => {
        let extraImageNameArr = [];
        if (res && res.data) {
          for (const key in res.data) {
            if (key != "extraImages" && key != "extraNewImages" && key != "bulkImages") {
              if (Object.hasOwnProperty.call(res.data, key)) {
                const element = res.data[key];
                const partName = element.name && element.name.split("/")[element.name.split("/").length - 1];
                extraImageNameArr.push(partName);
              }
            }
          }
        };
        if (retakePartName) {
          let obj = {};
          if (arrayForApplyTimeStamp.includes(retakePartName)) {
            obj = {
              [retakePartName]: Date.now(),
            };
          }
          this.setState({
            updatedImages: { ...obj }
          })
        }

        this.setState({
          extraImageNameArr,
          extraImages: res.data,
        }, () => {
          // (this.state.extraImageNameArr.length >= "15"  && this.props.hasOwnProperty('isFullView') ) && this.props.isFullView()
          //   });
          // })

          // const url1 = `${configuration.getExtraImages}?partnerId=${partnerId}&vin=${selectedVIN}&Extraimage=yes`;
          // axios
          //   .get(url1)
          //   .then((res) => {
          let extraImageNameArr = [];
          if (res && res.data) {
            for (const key in res.data) {
              if (key != "extraImages" && key != "extraNewImages" && key != "bulkImages") {
                if (Object.hasOwnProperty.call(res.data, key)) {
                  const element = res.data[key];
                  const partName = element.name && element.name.split("/")[element.name.split("/").length - 1];
                  extraImageNameArr.push(partName);
                }
              }
            }
          }
          let extraImageNameArr_1 = [];
          if (res && res.data.extraImages) {
            for (const key in res.data.extraImages) {
              if (Object.hasOwnProperty.call(res.data.extraImages, key)) {
                const element = res.data.extraImages[key];
                const partName = element.name && element.name.split("/")[element.name.split("/").length - 1];
                extraImageNameArr_1.push(partName);
              }
            }
          }
          let extraDocumnetImageNameArr = [];
          if (res && res.data.extraNewImages && localStorage.getItem("showDocumentExtraImage") == 1) {
            for (const key in res.data.extraNewImages) {
              if (Object.hasOwnProperty.call(res.data.extraNewImages, key)) {
                const element = res.data.extraNewImages[key];
                const isDocumentimage = allExtraDocumentImageArr.includes(element.part)
                const partName = element.name && element.name.split("/")[element.name.split("/").length - 1];
                if (isDocumentimage) {
                  extraDocumnetImageNameArr.push(partName);
                }
              }
            }
          }
          let documentImageNameArr = [];
          if (res && res.data.extraNewImages) {
            for (const key in res.data.extraNewImages) {
              if (Object.hasOwnProperty.call(res.data.extraNewImages, key)) {
                const element = res.data.extraNewImages[key];
                const partName = element.name && element.name.split("/")[element.name.split("/").length - 1];
                if (partName.includes("document")) {
                  documentImageNameArr.push(partName);
                }
              }
            }
          }
          let browseImageNameArr = [];
          if (res && res.data.extraNewImages) {
            for (const key in res.data.extraNewImages) {
              if (Object.hasOwnProperty.call(res.data.extraNewImages, key)) {
                const element = res.data.extraNewImages[key];
                const partName = element.name && element.name.split("/")[element.name.split("/").length - 1];
                if (partName.includes("browse")) {
                  browseImageNameArr.push(partName);
                }
              }
            }
          }
          let damageExtraImageNameArr_1 = [];
          if (res && res.data.extraNewImages) {
            for (const key in res.data.extraNewImages) {
              if (Object.hasOwnProperty.call(res.data.extraNewImages, key)) {
                const element = res.data.extraNewImages[key];
                const partName = element.name && element.name.split("/")[element.name.split("/").length - 1];
                if (partName.includes("pre-damage")) {
                  damageExtraImageNameArr_1.push(partName);
                }
              }
            }

            var damageExtraImg = [];
            damageExtraImageNameArr_1.map((item, i) => {
              damageExtraImg.push(item.split(".")[0]);
            });
            const uniqueArr = damageExtraImg.filter((value, index, self) => {
              return self.indexOf(value) === index;
            });
            this.setState({
              damageExtraImages: uniqueArr,
            });
          }

          let bulkImagesArr = [];
          if (res && res.data.bulkImages) {
            for (const key in res.data.bulkImages) {
              if (Object.hasOwnProperty.call(res.data.bulkImages, key)) {
                const element = res.data.bulkImages[key];
                const partName = element.name && element.name.split("/")[element.name.split("/").length - 1];
                bulkImagesArr.push(partName);
              }
            }
          }
          let preDamageImageArr = [];
          let preDamageImageArrName = [];
          if (res && res.data.extraNewImages) {
            const filterSvgPartImg = res.data.extraNewImages.filter((img) => {
              return img.part.includes("svg_")
            })
            filterSvgPartImg.map((img) => {
              const splitName = img.name.split("/")[img.name.split("/").length - 1]
              preDamageImageArr.push(img.name)
              preDamageImageArrName.push(splitName)
            })
            this.setState({ preDamageImagesArr: preDamageImageArr })
          }

          const sortedArray = [...bulkImagesArr].sort((a, b) => {
            // Extract the numeric part of the filenames using regular expressions
            const aNumber = parseInt(a.match(/\d+/)[0]);
            const bNumber = parseInt(b.match(/\d+/)[0]);
            return aNumber - bNumber; // Sort in ascending order
          });
          this.setState({
            bulkImagesArr: [...sortedArray]
          })
          var otherExtraImages = []
          extraImageNameArr_1.map((item, i) => {
            otherExtraImages.push(item.split(".")[0])
          })
          // remove duplicate value
          const uniqueArr = otherExtraImages.filter((value, index, self) => {
            return self.indexOf(value) === index;
          });
          uniqueArr.push("extraImage-x")
          this.setState({
            otherExtraImages: uniqueArr
          })
          var otherDocumentImages = [];
          documentImageNameArr.map((item, i) => {
            otherDocumentImages.push(item.split(".")[0]);
          });

          const uniqueDocArr = otherDocumentImages.filter((value, index, self) => {
            return self.indexOf(value) === index;
          });

          uniqueDocArr.push("document-x");

          uniqueDocArr.sort((a, b) => {
            if (a === "document-x") return 1;
            if (b === "document-x") return -1;
            const numA = parseInt(a.split("-")[1], 10);
            const numB = parseInt(b.split("-")[1], 10);
            return numA - numB;
          });

          this.setState({
            otherDocumentImages: uniqueDocArr
          });


          var otherBrowseImages = [];
          browseImageNameArr.map((item, i) => {
            otherBrowseImages.push(item.split(".")[0]);
          });

          const uniqueBrowseArr = otherBrowseImages.filter((value, index, self) => {
            return self.indexOf(value) === index;
          });

          uniqueBrowseArr.push("browse-x");

          uniqueBrowseArr.sort((a, b) => {
            if (a === "browse-x") return 1;
            if (b === "browse-x") return -1;
            const numA = parseInt(a.split("-")[1], 10);
            const numB = parseInt(b.split("-")[1], 10);
            return numA - numB;
          });

          this.setState({
            otherBrowseImages: uniqueBrowseArr
          });


          let newArr = this.state.extraImageNameArr.filter((_, index) => index < 15);
          let newArr_totalloss = this.state.extraImageNameArr.filter((_, index) => index > 14 && index < 33);
          this.setState({
            extraImageNameArr_1,
            newArr,
            newArr_totalloss,
            allOtherExtraImages: [
              ...res.data.extraImages,
              ...res.data.extraNewImages,
            ],
            extraDocumentImages: [...extraDocumnetImageNameArr],
            allOtherExtraImages_bulkImagesArr: [...res.data.extraImages, ...res.data.extraNewImages, ...res.data.bulkImages],
            arr: [...newArr, ...extraImageNameArr_1, ...damageExtraImageNameArr_1, ...sortedArray, ...newArr_totalloss, ...documentImageNameArr.reverse(), ...extraDocumnetImageNameArr,...preDamageImageArrName,...browseImageNameArr.reverse()].filter((e) => e)
            // arr: [...extraImageNameArr, ...extraImageNameArr_1]
          }, () => {
            this.checkExtraImageStatus();
            var disabledarr = this.state.arr.every((element) => typeof element === 'undefined')
            if (disabledarr) {
              this.props.hasOwnProperty('isdownloaddisabled') && this.props.isdownloaddisabled(true)
            } else {
              this.props.hasOwnProperty('isdownloaddisabled') && this.props.isdownloaddisabled(false)
            }
            // (this.state.allOtherExtraImages && this.props.hasOwnProperty('isFullView') && this.state.allOtherExtraImages.length > 0) && this.props.isFullView()
            (this.state.allOtherExtraImages_bulkImagesArr && this.props.hasOwnProperty('isFullView') && this.state.allOtherExtraImages_bulkImagesArr.length > 0) && this.props.isFullView()
          });
          // })
          // .catch((err) => {
          // });

        });
      })

  };

//   uploadImage = () => {
//     this.setState({ loading: true });
//     const { imageSrc, captureImageName, damageExtraImages, otherExtraImages, otherDocumentImages } = this.state;
//     const { vin } = this.props;
//     let captureDate = moment().utc(true).format(`DD-MM-YYYY hh:mm`);
  
//     // Reverse arrays for easier handling
//     let reverseOtherExtraImg = [...otherExtraImages].reverse();
//     let reverseDocumentImg = [...otherDocumentImages].reverse();
  
//     // Find the first available spot for otherExtraImages
//     let otherStringValue;
//     if (reverseOtherExtraImg.length > 0) {
//       const existingIndices = reverseOtherExtraImg.map(img => parseInt(img.split("-")[1]));
//       const availableIndex = this.findFirstAvailableIndex(existingIndices);
//       otherStringValue = availableIndex.toString();
//     }
  
//     // Find the first available spot for otherDocumentImages
//     let documentStringValue;
//     if (reverseDocumentImg.length > 0) {
//       const existingIndices = reverseDocumentImg.map(img => parseInt(img.split("-")[1]));
//       const availableIndex = this.findFirstAvailableIndex(existingIndices);
//       documentStringValue = availableIndex.toString();
//     }
  
//     // Find the first available spot for damageExtraImages
//     let filterDamageArray = damageExtraImages.reverse().filter((name) => {
//       return name.includes(captureImageName);
//     });
//     let stringValue;
//     if (filterDamageArray.length > 0) {
//       const existingIndices = filterDamageArray.map(img => parseInt(img.split("-")[2]));
//       const availableIndex = this.findFirstAvailableIndex(existingIndices);
//       stringValue = availableIndex.toString();
//     }
  
//     const url = configuration.uploadExtraImages;
//     let payload = {
//       img: imageSrc,
//       vin: vin || localStorage.getItem("selectedFile"),
//       part_type: this.state.extraImgRadioValue,
//       partnerId: localStorage.getItem("partnerId"),
//       partName: captureImageName === "extraImage-x"
//         ? otherExtraImages[0] !== "extraImage-x"
//           ? `extraImage-${otherStringValue}`
//           : `extraImage-${otherExtraImages.length}`
//         : captureImageName === "damage"
//           ? filterDamageArray.length > 0
//             ? `pre-damage-${stringValue}`
//             : `pre-damage-${filterDamageArray.length + 1}`
//           : captureImageName === "document-x"
//             ? otherDocumentImages[0] !== "document-x"
//               ? `document-${documentStringValue}`
//               : `document-${otherDocumentImages.length}`
//             : captureImageName.includes("/")
//               ? captureImageName.split("/")[1]
//               : captureImageName,
//       captureDate: captureDate
//     };
  
//     axios
//       .post(url, payload)
//       .then((res) => {
//         if (res.data.status === 200) {
//           this.getAllExtraImages(captureImageName);
//           Toast.fire({ type: "success", title: "Image upload successfully!" });
//           this.setState({
//             isLightBoxOpen: true,
//             isUploadModalOpen: false,
//             loading: false
//           });
//         } else {
//           Toast.fire({ type: "error", title: res.data.status === 500 ? "Internal server error!" : "Something went wrong!" });
//           this.setState({ loading: false, isUploadModalOpen: false });
//         }
//       })
//       .catch((err) => {
//         Toast.fire({ type: "error", title: "Something went wrong!" });
//         this.setState({ loading: false, isUploadModalOpen: false });
//       })
//       .finally(() => {
//         this.setState({
//           imageSrc: "",
//           isLightBoxOpen: false,
//           isUploadModalOpen: false,
//         });
//         this.refs.ExtraImage.value = "";
//       });
//   };
  
//   // Helper function to find the first available index
//  findFirstAvailableIndex = (existingIndices) => {
//     const sortedIndices = existingIndices.sort((a, b) => a - b);
//     for (let i = 1; i <= sortedIndices.length; i++) {
//       if (!sortedIndices.includes(i)) {
//         return i;
//       }
//     }
//     return sortedIndices.length + 1; // If no gaps, return the next available index
//   };
  

  checkExtraImageStatus = () => {
    const { allExtraImageSwissArr } = this.state;
    const isAnyOneImageUploaded = allExtraImageSwissArr.some(imageName => this.imageExistOrNot(imageName, true));
    // this.setState({ isAnyOneImageUploaded, allnewExtraImages: isAnyOneImageUploaded });
    this.setState({ isAnyOneImageUploaded });
  }


  imageExistOrNot = (name, boolean) => {
    const { extraImages } = this.state;
    let imgName = name.includes("/") ? name.split("/")[1] : name;
    if (boolean) {
      return Array.isArray(extraImages) ? false : Array.isArray(extraImages[imgName]) ? false : true
      // return Array.isArray(extraImages[imgName]) ? false : true;
    } else {
      return Array.isArray(extraImages) ? "black" : !Array.isArray(extraImages[imgName]) ? "red" : "black";
      // return Array.isArray(extraImages[imgName]) ? "black" : "red";
    }

  };
  extraDocumentImageExistOrNot = (name, boolean) => {
    const { allOtherExtraImages, allExtraDocumentImageArr } = this.state;
    if (allExtraDocumentImageArr.includes(name)) {
      let image = allOtherExtraImages.filter((obj) => obj.part === name);
      if (boolean) {
        return image.length > 0 ? true : false;
      } else {
        return image.length > 0 ? "red" : "black";
      }
    }
    if (boolean) {
      return false;
    }
    return "black";
  };

  handleDelete = () => {
    this.setState({
      isDeleteLoading: true,
    });
    const { imageName } = this.state;
    const url = configuration.deleteImage;
    // let img = this.state.allOtherExtraImages.filter((r) => r.part === imageName)
    let img = this.state.allOtherExtraImages_bulkImagesArr.filter((r) => r.part === imageName)
    const data = new FormData();
    if (this.state.extraImages[imageName]) {
      data.append("id", this.state.extraImages[imageName].id)
      data.append("part_name", this.state.extraImages[imageName].part)
      data.append("vin", this.state.extraImages[imageName].vin)
    } else {
      data.append("id", img[0].id)
      data.append("part_name", img[0].part)
      data.append("vin", img[0].vin)
    };
    data.append("partnerId", localStorage.getItem("partnerId"));
    data.append("is_type", "web_app");
    data.append("is_extara_image", '2');
    axios
      .post(url, data)
      .then((res) => {
        this.setState(
          {
            isDeleteLoading: false,
            isLightBoxOpen: false,
            // isLightBoxOpen: true,
          },
          () => {
            console.log('res.data.status === true :>> ', res.data.status);
            if (res.data.success === true) {
              if (this.state.extraImages[imageName]) {
                this.getAllExtraImages(true, this.state.extraImages[imageName].name);
              } else {
                this.getAllExtraImages(true, imageName);
              }

              Toast.fire({
                type: "success",
                title: "Image deleted successfully!",
              });
            } else {
              Toast.fire({
                type: "error",
                title: "Something went wrong!",
              });
            }
          }
        );
      })
      .catch((err) => {
        this.setState({
          isDeleteLoading: false,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      });
  };

  toggleEdit = async () => {
    this.setState({
      isEditLoading: true,
    });
    this.getBase64()
  };

  getBase64 = async (isDownload) => {
    const { isEditor, isLightBoxOpen, imageName } = this.state;
    const partner_id = localStorage.getItem("partnerId");
    const { vin } = this.props;
    await axios
      .get(configuration.extraImageToBase64, {
        params: {
          partner_id,
          vin_number: vin ? vin : localStorage.getItem("selectedFile"),
          img_name: imageName,
        },
      })
      .then((response) => {
        if (response !== undefined) {
          this.setState({
            ...this.state,
            data64Url: response.data.base64_img,
            imageUrl: imageName,
            isEditLoading: false,
          });
        }
      })
      .catch((err) => {
      })
      .finally(() => {
        this.setState({
          isEditor: isDownload ? false : !isEditor,
          isLightBoxOpen: !isLightBoxOpen,
          isEditLoading: false,
        });
      });
  }

  handleRetake = () => {
    this.refs.ExtraImage.click();
  };

  handlerotate = () => {
    this.setState({
      isRotateLoading: true,
    });
    const { imageName, arr } = this.state;

    const { vin } = this.props;
    // let partnerId = localStorage.getItem("partnerId");
    // var images = `${imageName}.jpg`
    var images_name = arr.find(item => item && item.split(".")[0] == imageName)


    let url = configuration.Rotate_image;
    const formData = new FormData();
    formData.append("img", images_name);
    formData.append("vin", vin || localStorage.getItem("selectedFile"));
    formData.append("partnerId", localStorage.getItem("partnerId"));
    formData.append("partName", imageName.includes("/") ? imageName.split("/")[1] : imageName);
    axios
      .post(url, formData)
      .then((res) => {
        const imageNameKey = imageName.includes("/") ? imageName.split("/")[1] : imageName;

        let obj = {};
        if (arrayForApplyTimeStamp.includes(imageNameKey)) {
          obj = {
            [imageNameKey]: Date.now(),
          };
        }

        this.setState(
          {
            isRotateLoading: false,
            uniqueImageSuffix: Date.now(),
            updatedImages: { ...this.state.updatedImages, ...obj }
          },
          () => {
            if (res.data.status === 200) {
              // this.getAllExtraImages();
              // this.props.getPhotoAppExtraImages();
              // res.data.hasOwnProperty("isRotate") && this.props.isRotate(imageName);
              // Toast.fire({
              //   type: "success",
              //   title: "Image upload successfully!",
              // });
              this.setState({
                loading: false,
              });
            } else {
              Toast.fire({
                type: "error",
                title: "Something went wrong!",
              });
              this.setState({
                loading: false
              });
            }
          }
        );
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
        this.setState({
          loading: false,
        })
      })
      .finally(() => {
        this.setState({
          loading: false,
        })
        this.refs.ExtraImage.value = ""
      });
  }

  upload = () => {
    this.setLoader(true);
    const { imageName, extraImages, arr } = this.state;
    var images_name = arr.filter(item => item && item.split(".")[0] == imageName)
    var ext = images_name.length && images_name[0].split(".")[1];
    const { vin } = this.props;
    let partnerId = localStorage.getItem("partnerId");
    var imageEditorCanvas = document.getElementsByClassName("lower-canvas");
    var base64image = imageEditorCanvas[0].toDataURL("image/" + ext, 1.0);
    // var base64image = imageEditorCanvas[0].toDataURL("image/jpeg", 1.0);
    let url = configuration.uploadExtraImagesNew;
    let utcHours = moment().toString().split("GMT")[1].slice(0, 3) + ':' + moment().toString().split("GMT")[1].slice(3, 5);
    let captureDate = moment().utc(false).format(`DD-MM-YYYY hh:mm ${utcHours} UTC`);
    let payload = {
      // img: base64image.replace("jpeg", "jpg"),
      img: base64image,
      vin: vin || localStorage.getItem('selectedFile'),
      partnerId,
      partName: imageName.includes("/") ? imageName.split("/")[1] : imageName,
      captureDate: captureDate
    };
    axios
      .post(url, payload)
      .then((res) => {
        this.setLoader(false);
        this.setState({
          isEditor: false,
        });
        if (res.data.status === 200) {
          this.getAllExtraImages(payload.partName);
          // if(this.props.hasOwnProperty('getPhotoAppExtraImages')) {
          //   this.props.getPhotoAppExtraImages();
          // }
          Toast.fire({
            type: "success",
            title: "Image upload successfully!",
          });
        } else {
          Toast.fire({
            type: "error",
            title: "Something went wrong!",
          });
        }
      })
      .catch((err) => {
        this.setLoader(false);
        this.setState({
          isEditor: false,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      })
  };

  setLoader = (loader) => {
    if (loader) {
      document.getElementsByClassName(
        "upload_image_photo_app_gallery"
      )[0].innerHTML = "Uploading...";
    } else {
      document.getElementsByClassName(
        "upload_image_photo_app_gallery"
      )[0].innerHTML = "Ok";
    }
  };

  DownlaodImage = async () => {
    await this.getBase64(true);
    await this.downloadBase64File(this.state.data64Url);
  }

  getImageName = () => {
    const { imageName, extraImages } = this.state;
    let fileName = extraImages[imageName.includes("/") ? imageName.split("/")[1] : imageName].name.split('/')
    fileName = fileName[fileName.length - 1].split(".");
    fileName = `${this.lang(fileName[0])}.${fileName[1]}`
    return fileName;
  }

  downloadBase64File = async (base64Data) => {
    const downloadLink = document.createElement("a");
    downloadLink.href = base64Data;
    downloadLink.download = await this.getImageName();
    downloadLink.click();
  }

  showchange = (e) => {
    this.setState({
      allnewExtraImages: e.target.checked
    })
  }

  otherImageExistOrNot1 = (name, boolean) => {
    const { allOtherExtraImages, otherExtraImages } = this.state;
    if (otherExtraImages.includes(name)) {
      let image = allOtherExtraImages.filter((obj) => (obj.part).split('.')[0] === name);
      if (boolean) {
        return image.length > 0 ? true : false;
      } else {
        return image.length > 0 ? "red" : "black";
      }
    }
    if (boolean) {
      return false;
    }
    return "black";
  }
  damageImgExistOrNot = (name, boolean) => {
    const { allOtherExtraImages, damageExtraImages } = this.state;
    if (damageExtraImages.includes(name)) {
      let image = allOtherExtraImages.filter((obj) => obj.part === name);

      if (boolean) {
        return image.length > 0 ? true : false;
      } else {
        return image.length > 0 ? "red" : "black";
      }
    }
    if (boolean) {
      return false;
    }
    return "black";
  };
  documentImageExistOrNot = (name, boolean) => {
    const { allOtherExtraImages, otherDocumentImages } = this.state;
    if (otherDocumentImages.includes(name)) {
      let image = allOtherExtraImages.filter((obj) => obj.part === name);

      if (boolean) {
        return image.length > 0 ? true : false;
      } else {
        return image.length > 0 ? "red" : "black";
      }
    }
    if (boolean) {
      return false;
    }
    return "black";
  };
  browseImageExistOrNot = (name, boolean) => {
    const { allOtherExtraImages, otherBrowseImages } = this.state;
    if (otherBrowseImages.includes(name)) {
      let image = allOtherExtraImages.filter((obj) => obj.part === name);

      if (boolean) {
        return image.length > 0 ? true : false;
      } else {
        return image.length > 0 ? "red" : "black";
      }
    }
    if (boolean) {
      return false;
    }
    return "black";
  };
  otherImageExistOrNot = (name, boolean) => {
    const { bulkImagesArr } = this.state;
    if (bulkImagesArr.includes(name)) {
      // let imgName = name.name.split(".")[0]
      let imgName = name.split(".")[0]
      return imgName
    }
  }
  handleToggleExtraimages = (name) => {
    const { isOpenImage } = this.props;
    if (isOpenImage) {
      this.setState({
        imageName: name.split(".")[0],
        captureImageName: name.split(".")[0],
      }, () => this.getIndex_1()
      );
    } else {

      this.setState({
        imageSrc: "",
        captureImageName: name.split(".")[0],
      });
      this.setState({
        imageName: name.split(".")[0]
      }, () => this.getIndex_1());
    }
  };

  getIndex_1 = async () => {
    const { isLightBoxOpen, arr, extraImageNameArr_1, imageName, bulkImagesArr } = this.state;
    arr.map((image, i) => {
      let arr = image ? image.split('.')[0] : "";
      if (arr === imageName) {
        this.setState({
          imagesModalCurrentSourceIndex: i,
        }, () => this.setState({
          isLightBoxOpen: !isLightBoxOpen,
        }));
      };
    })
  }

  PostEditorChange = () => {
    const { vin } = this.props;

    const partnerId = localStorage.getItem("partnerId");
    const vinData = vin || localStorage.getItem("selectedFile");
    const url1 =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vinData}`;
    this.setState({
      deAuthLoading: true
    })
    let payload = {
      CarTotalLoss: this.state.allnewExtraImages
    }
    axios.post(url1, payload)
  }

  getData = async () => {
    const { vin } = this.props;

    await axios.get(configuration.getData, {
      params: {
        vin: vin ? vin : localStorage.getItem("selectedFile"),
        partnerId: localStorage.getItem('partnerId')
      }
    }).then((res) => {
      if (res) {
        this.props.reportAuthorized({
          Authorized : res.data.Authorized,
          DATReportAuthorized : res.data.DATReportAuthorized,
          MiniReportAuthorized : res.data.MiniReportAuthorized,
          MiniReportAuthorized2 : res.data.MiniReportAuthorized2,
          FullReportAuthorized2 : res.data.FullReportAuthorized2,
          DetailedReportAuthorized : res.data.DetailedReportAuthorized,
          AmericanReportAuthorized : res.data.AmericanReportAuthorized,
        })
        this.setState({
          allnewExtraImages: res.data.CarTotalLoss,
          setOrderId: res.data.OrderNo,
          setActualVin: res.data.ActualVin,
          authorized : res.data.Authorized
        })
      }
    }).catch(err => console.log(err));
  }

  internalStatus = async (vin) => {
    const url = configuration.internalStatus;
    const { allnewExtraImages, setOrderId, setActualVin } = this.state;
    const vinData = vin || localStorage.getItem("selectedFile");
    let payload = {
      vin: setOrderId || vinData || setActualVin,
      status: 4,
      total_loss: allnewExtraImages === true ? 1 : 0,
    }
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    await axios.post(url, payload, { headers })
  }

  totalLossCar = (e) => {
    this.setState({
      deAuthLoading: true,
    });
    Swal.fire({
      title: `<h3 className="swal-custome-text">${this.lang("are you sure your car is total loss?")}</h3>`,
      showCancelButton: true,
      confirmButtonText: this.lang("Yes"),
      cancelButtonText: this.lang("No"),
      confirmButtonColor: "#d80707",
      allowEscapeKey: false,
      allowOutsideClick: false,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.value === true) {
        // this.updateJSON(false);
        this.setState({
          allnewExtraImages: !this.state.allnewExtraImages
        })
        this.internalStatus()
        this.PostEditorChange()
      }
    });
  };
  toggleUploadModal = (name) => {
    if (this.state.authorized) {
      Toast.fire({
        type: "error",
        title: this.lang("ThisVINisAuthorized"),
      });
      return
    }
    if (this.props.isDashboard) {
      this.setState({
        extraImgRadioValue: "1",
        uploadPartName: "damage",
        isUploadModalOpen: !this.state.isUploadModalOpen,
      });
    }
  };

  handleRadioChange = (e) => {
    this.setState({
      extraImgRadioValue: e.target.value,
      uploadPartName: e.target.value == 1 ? "damage" : "extraImage-x",
    });
  };
  render() {
    const {
      allExtraImageArr,
      imageName,
      isLightBoxOpen,
      isEditLoading,
      isDeleteLoading,
      loading,
      isEditor,
      extraImages,
      captureImageName,
      imagesModalCurrentSourceIndex,
      extraImageNameArr,
      isRotateLoading,
      allOtherExtraImages,
      isPreDamageImageLightBoxOpen,
      preDamageImagesArr,
      extraImageNameArr_1,
      extraImageNameArr_2,
      showExtraImage,
      showExtraImage1111,
      image,
      index,
      isFullView,
      arr,
      uniqueImageSuffix,
      updatedImages,
      damageExtraImages,
      allExtraDocumentImageArr,
      extraDocumentImages

    } = this.state;
    let { vin, showOption, showNextPrevButton, isDashboard } = this.props;
    vin = vin || localStorage.getItem("selectedFile");
    let partnerId = localStorage.getItem('partnerId');
    const { xl, lg, md, sm, col, mb, viewOnly, isShowImage } = this.props;
    const client = localStorage.getItem('client');
    let toolbarButtons
    if (!showOption) {
      toolbarButtons = [
        // <div className="photo_app_image_lightbox_wrapper">
        //   <button
        //     onClick={() => this.DownlaodImage()}
        //   >
        //     <i className="fa fa-download"></i>
        //   </button>
        // </div>
      ]
    } else {
      toolbarButtons = [
        <>
          <div className="photo_app_image_lightbox_wrapper">
            <button
              onClick={() => this.setState({ isLightBoxOpen: !isLightBoxOpen })}
            >
              <i className="fa fa-check"></i>

            </button>
            <button
              disabled={this.state.authorized}
            onClick={() => this.handleRetake()}>
              <i className="fa fa-camera"></i>
            </button>
            <button
              disabled={this.state.authorized}
            onClick={() => this.toggleEdit()}>
              {isEditLoading ? <Spinner style={{ height: '1rem', width: '1rem' }} /> : <i className="fa fa-pencil"></i>}
            </button>
            <button 
              disabled={this.state.authorized}
            onClick={() => this.handlerotate()}>
              {isRotateLoading ? <Spinner style={{ height: '1rem', width: '1rem' }} /> : <i className="fa fa-repeat"></i>}
              {/* <i className="fa fa-repeat"></i> */}
            </button>
            <button 
              disabled={this.state.authorized}
            onClick={() => this.handleDelete()}>
              {isDeleteLoading ? <Spinner style={{ height: '1rem', width: '1rem' }} /> : <i className="fa fa-trash"></i>}
            </button>
          </div>
        </>,
      ];
    }
    const reversedDamageExtraImages = [...damageExtraImages].reverse();

    return (
      <>
        <Row className={`photo_app_main_wrapper ${allOtherExtraImages && allOtherExtraImages.length > 0 ? "photo_gallery_extraImage" : "photo_gallery"}`}>
          <input
            type="file"
            name="image"
            id="file"
            ref="ExtraImage"
            accept="image/*"
            capture="environment"
            style={{ display: "none" }}
            onChange={(e) => this.capture(e)}
          />
          <input
            type="file"
            name="image"
            id="file"
            ref="UploadImages"
            accept="image/*"
            multiple
            style={{ display: "none" }}
            onChange={(e) => this.captureBrowseImages(e)}
          />
          {
            (client == "ROM" && (localStorage.getItem("showDocumentExtraImage") == 1)) &&
            <>
              <div className="col-lg-12">
                <h4>{this.lang("Documents")}</h4>
              </div>
              {allExtraDocumentImageArr && allExtraDocumentImageArr.length > 0 && allExtraDocumentImageArr.map((name, i) => {
               let imageSrc = this.state.allOtherExtraImages.find((item)=>{
               return item.part == name
               })
                return (
                  <div
                    className={`col-xl-${xl} col-lg-${lg} col-md-${md} col-sm-${sm} col-${col} mb-${mb} image-card-wrapper`}
                    key={i}
                  >
                    <div
                      className={`images-border-card ${this.extraDocumentImageExistOrNot(name, true) &&
                        isShowImage &&
                        "coloroverlay"
                        }`}
                      style={{
                        backgroundImage:
                          this.extraDocumentImageExistOrNot(name, true) && isShowImage
                            ?
                            isDashboard ?
                              `url(${imageSrc.name}?${Date.now})`
                              :
                              (updatedImages.hasOwnProperty(name) ?
                                `url(${imageSrc.name}?${updatedImages[name]})`
                                :
                                `url(${imageSrc.name}`)
                            : "",
                      }}
                      onClick={() => {
                        !viewOnly && this.handleToggle(name);

                      }}
                    >
                      {(name === captureImageName) && loading ?
                        <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                          <span className="sr-only">Loading...</span>
                        </div>
                        :
                        this.extraDocumentImageExistOrNot(name, true) && isShowImage ? (
                          <img
                            className="document_imag w-100"
                            style={{
                              visibility: "hidden",
                            }}
                            src={imageSrc.name}
                            alt={name}
                          />
                        ) : name === "paymentDetails" ? (
                          <img
                            className="document_image"
                            src={require(`../../../views/Dashboard/icon/document-${this.extraDocumentImageExistOrNot(
                              name
                            )}.svg`)}
                            alt={name}
                          />
                        ) : (
                          <img
                            className=""
                            src={require(`../../../views/Dashboard/icon/${this.extraDocumentImageExistOrNot(
                              name
                            )}-camera.svg`)}
                            alt={name}
                          />
                        )
                      }
                      <p className="parts-name"> {this.lang(name)}</p>
                    </div>
                  </div>
                );
              })}
              <div className="col-lg-12 mt-2">
                <h4>{this.lang("Images")}</h4>
              </div>
            </>
          }
          {allExtraImageArr.map((name, i) => {
            let imageSrc = extraImages[
              name.includes("/") ? name.split("/")[1] : name
            ]
              ? extraImages[name.includes("/") ? name.split("/")[1] : name].name
              : "";
            return (
              <div
                className={`col-xl-${xl} col-lg-${lg} col-md-${md} col-sm-${sm} col-${col} mb-${mb} image-card-wrapper`}
                key={i}
              >
                <div
                  className={`images-border-card ${this.imageExistOrNot(name, true) &&
                    isShowImage &&
                    "coloroverlay"
                    }`}
                  style={{
                    backgroundImage:
                      this.imageExistOrNot(name, true) && isShowImage
                        ?
                        isDashboard ?
                          `url(${imageSrc}?${Date.now})`
                          :
                          (updatedImages.hasOwnProperty(name) ?
                            `url(${imageSrc}?${updatedImages[name]})`
                            :
                            `url(${imageSrc}`)
                        : "",
                  }}
                  onClick={() => {
                    !viewOnly && this.handleToggle(name);

                  }}
                >
                  {(name === captureImageName) && loading ?
                    <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                      <span className="sr-only">Loading...</span>
                    </div>
                    :
                    this.imageExistOrNot(name, true) && isShowImage ? (
                      <img
                        className="document_imag w-100"
                        style={{
                          visibility: "hidden",
                        }}
                        src={imageSrc}
                        alt={name}
                      />
                    ) : name === "paymentDetails" ? (
                      <img
                        className="document_image"
                        src={require(`../../../views/Dashboard/icon/document-${this.imageExistOrNot(
                          name
                        )}.svg`)}
                        alt={name}
                      />
                    ) : (
                      <img
                        className=""
                        src={require(`../../../views/Dashboard/icon/${this.imageExistOrNot(
                          name
                        )}-camera.svg`)}
                        alt={name}
                      />
                    )
                  }
                  <p className="parts-name"> {this.lang(name)}</p>
                </div>
              </div>
            );
          })}



          {/* {reversedDamageExtraImages && reversedDamageExtraImages.length>0 && reversedDamageExtraImages.map((name, idx) => {
             let imageObj = this.state.allOtherExtraImages.length>0 && this.state.allOtherExtraImages.filter((obj) => obj && obj.part === name)
             let img = imageObj[0] && imageObj[0].name
                return (<div
                className={`col-xl-${xl} col-lg-${lg} col-md-${md} col-sm-${sm} col-${col} mb-${mb} image-card-wrapper`}
                  key={idx}
                >
                  <div 
                  className={`images-border-card ${this.damageImgExistOrNot(name, true) &&
                    isShowImage &&
                    "coloroverlay"
                    }`}
                  style={{
                    backgroundImage:
                      this.damageImgExistOrNot(name, true) && isShowImage
                        ? `url(${img}`
                        : "",
                  }}
                   onClick={() => !viewOnly && this.damageImgExistOrNot(name, true)
                    ? this.handleToggle(name)
                    : this.toggleUploadModal(name)}>
                    {(name === captureImageName) && loading ?
                      <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                        <span className="sr-only">Loading...</span>
                      </div>
                        :
                        this.damageImgExistOrNot(name, true) && isShowImage ? 
                         (
                          <img
                            className="document_imag w-100"
                            style={{
                              visibility: "hidden",
                            }}
                            src={name}
                            alt={name}
                          />
                        )
                      :
                     (
                        <img
                          className=""
                          src={require(`../../../views/Dashboard/icon/${this.damageImgExistOrNot(
                            name
                          )}-camera.svg`)}
                          alt={name}
                        />
                      )
                    }
                    <p className="parts-name">{`${this.lang("Damage")} - ${name.split('-')[2]}`}</p>
                  </div>
                </div>
                )
          })} */}


          {reversedDamageExtraImages &&
            reversedDamageExtraImages
              .filter((name) => name.toLowerCase().includes("damage"))
              .map((name, idx) => {

                const imageObj =
                  this.state.allOtherExtraImages.length > 0 &&
                  this.state.allOtherExtraImages.filter((obj) => obj && obj.part === name);
                const img = imageObj[0] && imageObj[0].name;
                return (
                  <div
                    className={`col-xl-${xl} col-lg-${lg} col-md-${md} col-sm-${sm} col-${col} mb-${mb} image-card-wrapper`}
                    key={idx}
                  >
                    <div
                      className={`images-border-card ${this.damageImgExistOrNot(name, true) && isShowImage && "coloroverlay"
                        }`}
                      style={{
                        backgroundImage:
                          this.damageImgExistOrNot(name, true) && isShowImage
                            ? `url(${img})`
                            : "",
                      }}
                      onClick={() =>
                        !viewOnly && this.damageImgExistOrNot(name, true)
                          ? this.handleToggle(name)
                          : this.toggleUploadModal(name)
                      }
                    >
                      {name === captureImageName && loading ? (
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1.5rem", height: "1.5rem" }}
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : this.damageImgExistOrNot(name, true) && isShowImage ? (
                        <img
                          className="document_imag w-100"
                          style={{ visibility: "hidden" }}
                          src={name}
                          alt={name}
                        />
                      ) : (
                        <img
                          className=""
                          src={require(`../../../views/Dashboard/icon/${this.damageImgExistOrNot(
                            name
                          )}-camera.svg`)}
                          alt={name}
                        />
                      )}
                      <p className="parts-name">
                        {`${this.lang("Damage")} - ${name.split("-")[2]}`}
                      </p>
                    </div>
                  </div>
                );
              })}


          {this.state.otherExtraImages && this.state.otherExtraImages.length > 0 && this.state.otherExtraImages.map((name, idx) => {
            let imageObj = this.state.allOtherExtraImages.length > 0 && this.state.allOtherExtraImages.filter((obj) => obj && obj.part === name)
            let img = imageObj[0] && imageObj[0].name
            return (<div
              className={`col-xl-${xl} col-lg-${lg} col-md-${md} col-sm-${sm} col-${col} mb-${mb} image-card-wrapper`}
              key={idx}
            >
              <div
                className={`images-border-card ${this.otherImageExistOrNot1(name, true) &&
                  isShowImage &&
                  "coloroverlay"
                  }`}
                style={{
                  backgroundImage:
                    this.otherImageExistOrNot1(name, true) && isShowImage
                      ? `url(${img}`
                      : "",
                }}
                onClick={() => !viewOnly && this.otherImageExistOrNot1(name, true)
                  ? this.handleToggle(name)
                  : this.toggleUploadModal(name)}>
                {(name === captureImageName) && loading ?
                  <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                    <span className="sr-only">Loading...</span>
                  </div>
                  :
                  this.otherImageExistOrNot1(name, true) && isShowImage ?
                    (
                      <img
                        className="document_imag w-100"
                        style={{
                          visibility: "hidden",
                        }}
                        src={name}
                        alt={name}
                      />
                    )
                    :
                    (
                      <img
                        className=""
                        src={require(`../../../views/Dashboard/icon/${this.otherImageExistOrNot1(
                          name
                        )}-camera.svg`)}
                        alt={name}
                      />
                    )
                }
                <p className="parts-name">{name == "extraImage-x" ? (
                  `${this.lang(
                    "Damage"
                  )} - ${name.split("-")[1].toUpperCase()}`
                ) : (`${this.lang(
                  "pre-Damage"
                )} - ${name.split("-")[1].toUpperCase()}`)}</p>
              </div>
            </div>
            )
          })}

          {this.state.otherDocumentImages && this.state.otherDocumentImages.length > 0 && this.state.otherDocumentImages.map((name, idx) => {
            let imageObj = this.state.allOtherExtraImages.length > 0 && this.state.allOtherExtraImages.filter((obj) => obj && obj.part === name)
            let img = imageObj[0] && imageObj[0].name
            return (<div
              className={`col-xl-${xl} col-lg-${lg} col-md-${md} col-sm-${sm} col-${col} mb-${mb} image-card-wrapper`}
              key={idx}
            >
              <div
                className={`images-border-card ${this.documentImageExistOrNot(name, true) &&
                  isShowImage &&
                  "coloroverlay"
                  }`}
                style={{
                  backgroundImage:
                    this.documentImageExistOrNot(name, true) && isShowImage
                      ? `url(${img}`
                      : "",
                }}

                onClick={() => {
                  !viewOnly && this.handleToggle(name);

                }}>
                {(name === captureImageName) && loading ?
                  <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                    <span className="sr-only">Loading...</span>
                  </div>
                  :
                  this.documentImageExistOrNot(name, true) && isShowImage ?
                    (
                      <img
                        className="document_imag w-100"
                        style={{
                          visibility: "hidden",
                        }}
                        src={name}
                        alt={name}
                      />
                    )
                    :
                    (
                      <img
                        className=""
                        src={require(`../../../views/Dashboard/icon/${this.documentImageExistOrNot(
                          name
                        )}-camera.svg`)}
                        alt={name}
                      />
                    )
                }
                <p className="parts-name">{this.lang(name.split("-")[0])} - {name.split("-")[1]}</p>
              </div>
            </div>
            )
          })}
          {this.state.otherBrowseImages && this.state.otherBrowseImages.length > 0 && this.state.otherBrowseImages.map((name, idx) => {
            let imageObj = this.state.allOtherExtraImages.length > 0 && this.state.allOtherExtraImages.filter((obj) => obj && obj.part === name)
            let img = imageObj[0] && imageObj[0].name
            return (<div
              className={`col-xl-${xl} col-lg-${lg} col-md-${md} col-sm-${sm} col-${col} mb-${mb} image-card-wrapper`}
              key={idx}
            >
              <div
                className={`images-border-card ${this.browseImageExistOrNot(name, true) &&
                  isShowImage &&
                  "coloroverlay"
                  }`}
                style={{
                  backgroundImage:
                    this.browseImageExistOrNot(name, true) && isShowImage
                      ? `url(${img}`
                      : "",
                }}

                onClick={() => {
                  !viewOnly && this.handleToggle(name);

                }}>
                {(name === captureImageName) && loading ?
                  <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                    <span className="sr-only">Loading...</span>
                  </div>
                  :
                  this.browseImageExistOrNot(name, true) && isShowImage ?
                    (
                      <img
                        className="document_imag w-100"
                        style={{
                          visibility: "hidden",
                        }}
                        src={name}
                        alt={name}
                      />
                    )
                    :
                    (
                      <img
                        className=""
                        src={require(`../../../views/Dashboard/icon/${this.browseImageExistOrNot(
                          name
                        )}-camera.svg`)}
                        alt={name}
                      />
                    )
                }
                <p className="parts-name">{this.lang(name.split("-")[0])} - {name.split("-")[1]}</p>
              </div>
            </div>
            )
          })}

          {
            !isDashboard &&
            <div className={`col-xl-${xl} col-lg-${lg} col-md-${md} col-sm-${sm} col-${col} mb-${mb} image-card-wrapper`}>
              <div
                style={{
                  backgroundImage:
                    preDamageImagesArr.length > 0 && `url(${preDamageImagesArr[0]}?${Date.now()})`
                }}
                className={preDamageImagesArr.length > 0 ? 'images-border-card false coloroverlay' : "images-border-card false"}
                // className={`images-border-card false${
                //   preDamageImagesArr.length > 0 && `coloroverlay`}`}
                onClick={() => {
                  preDamageImagesArr.length > 0 && this.setState({
                    isPreDamageImageLightBoxOpen: !isPreDamageImageLightBoxOpen
                  })
                }}

              >
                {

                  preDamageImagesArr.length == 0 ?
                    (

                      <img
                        className=""
                        src={require(`../../../views/Dashboard/icon/black-camera.svg`)}

                      />
                    ) : (
                      <img
                        className=""
                        style={{ visibility: "hidden" }}
                        src={require(`../../../views/Dashboard/icon/black-camera.svg`)}

                      />
                    )
                }


                <p class="parts-name">{this.lang("Total Extra Images")}</p>
              </div>
            </div>
          }


          {showNextPrevButton ?
            this.state.bulkImagesArr && this.state.bulkImagesArr.map((name, i) => {
              let images = name;
              return (
                <div
                  className={`col-xl-${xl} col-lg-${lg} col-md-${md} col-sm-${sm} col-${col} mb-${mb} image-card-wrapper`}
                  key={i}
                >
                  <div
                    className={`images-border-card ${this.otherImageExistOrNot(name, true) &&
                      isShowImage &&
                      "coloroverlay"
                      }`}
                    style={{
                      backgroundImage:
                        this.otherImageExistOrNot(name, true) && isShowImage
                          ? `url(${configuration.imagePath}/scanImages/${partnerId}/${vin}/${images}`
                          : "",
                    }}
                    onClick={() => {
                      !viewOnly && this.handleToggleExtraimages(name);
                    }}
                  >
                    {(name === captureImageName) && loading ?
                      <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                        <span className="sr-only">Loading...</span>
                      </div>
                      :
                      this.otherImageExistOrNot(name, true) && isShowImage ? (
                        <img
                          className="document_imag w-100"
                          style={{
                            visibility: "hidden",
                          }}
                          src={name.name}
                          alt={name.part}
                        />
                      )
                        : name === "paymentDetails" ? (
                          <img
                            className="document_image"
                            src={require(`../../../views/Dashboard/icon/document-${this.otherImageExistOrNot(
                              name
                            )}.svg`)}
                            alt={name.part}
                          />
                        )
                          :

                          (
                            <img
                              className=""
                              src={require(`../../../views/Dashboard/icon/red-camera.svg`)}
                              alt={name.part}
                            />
                          )
                    }
                    <p className="parts-name"> {`${this.lang("pre-Damage")} - 0${this.lang(name.split("-")[1].split(".")[0])}`}</p>
                    {/* <p className="parts-name"> {`${this.lang("pre-Damage")} - ${this.lang(name.part.split("-")[1])}`}</p> */}
                  </div>
                </div>
              );
            }) : ""
          }
        </Row>
        <div className="row mb-0 d-flex justify-content-center">
          <div className="col-lg-12 text-center mt-2">
            <h2 className="extraimage-gallery-heading">{this.lang("is the car a total loss?")}</h2>
          </div>
          <div className="col-lg-12 main_switch_wrapper">
            <label className="switch">
              <input
              disabled={this.state.authorized}
                className="switch-input"
                type="checkbox"
                name="allnewExtraImages"
                id="allnewExtraImages"
                value={this.state.allnewExtraImages}
                onClick={(e) => this.totalLossCar(e)}
                checked={this.state.allnewExtraImages}
              // disabled={this.state.allnewExtraImages}
              />
              <span className="switch-label" data-on={this.lang("Yes")} data-off={this.lang("No")}></span>
              <span className="switch-handle"></span>
            </label>
          </div>
        </div>

        {this.state.allnewExtraImages === true &&
          <>
            <div className="col-lg-12 text-center">
              <p className="border_line_radius"></p>
              <h2 className="extraimage-gallery-heading mt-3 mb-5">{this.lang("additional images for total loss")}</h2>
            </div>

            <Row className="photo_app_main_wrapper">
              <input
                type="file"
                name="image"
                id="file"
                // ref="ExtraImage"
                accept="image/*"
                capture="environment"
                style={{ display: "none" }}
                onChange={(e) => this.capture(e)}
              />
              {this.state.allExtraImageSwissArr.map((name, i) => {
                let imageSrc = extraImages[
                  name.includes("/") ? name.split("/")[1] : name
                ]
                  ? extraImages[name.includes("/") ? name.split("/")[1] : name].name
                  : "";
                return (
                  <div
                    className={`col-xl-${xl} col-lg-${lg} col-md-${md} col-sm-${sm} col-${col} mb-${mb} image-card-wrapper`}
                    key={i}
                  >
                    <div
                      className={`images-border-card ${this.imageExistOrNot(name, true) &&
                        isShowImage &&
                        "coloroverlay"
                        }`}
                      style={{
                        backgroundImage:
                          this.imageExistOrNot(name, true) && isShowImage
                            ? `url(${imageSrc})`
                            : "",
                      }}
                      onClick={() => {
                        !viewOnly && this.handleToggle(name);
                      }}
                    >
                      {(name === captureImageName) && loading ?
                        <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                          <span className="sr-only">Loading...</span>
                        </div>
                        :
                        this.imageExistOrNot(name, true) && isShowImage ? (
                          <img
                            className="document_imag w-100"
                            style={{
                              visibility: "hidden",
                            }}
                            src={imageSrc}
                            alt={name}
                          />
                        ) : (name === "PurchaseInvoiceReceipt" || name === "Leasingcontract" ||
                          name === "Investments" || name === "Invoice") ? (
                          <img
                            className="document_image"
                            src={require(`../../../views/Dashboard/icon/document-${this.imageExistOrNot(
                              name
                            )}.svg`)}
                            alt={name}
                          />
                        ) : (
                          <img
                            className=""
                            src={require(`../../../views/Dashboard/icon/${this.imageExistOrNot(
                              name
                            )}-camera.svg`)}
                            alt={name}
                          />
                        )
                      }
                      <p className="parts-name"> {this.lang(name)}</p>
                    </div>
                  </div>
                );
              })}
            </Row>
          </>
        }
        {/* Editor modal */}
        <Modal
          size="xl"
          isOpen={isEditor}
          toggle={() => this.setState({ isEditor: !this.state.isEditor })}
          className="modal1 image_editor_modal_main"
        >
          <ModalBody>
            <PhotoGalleryImageEditor
              prepopulate={true}
              staticImageUrl={this.state.imageUrl}
              imageUrl={this.state.data64Url}
              vin={vin}
              imageName={imageName}
              upload={() => this.upload()}
            />
          </ModalBody>
        </Modal>
        {/* <Modal
            isOpen={this.state.isUploadModalOpen}
            toggle={this.toggleUploadModal}
          >
            <ModalHeader toggle={this.toggleUploadModal}>
              Modal title
            </ModalHeader>
            <ModalBody>
              <Label>{this.lang("Damage")}</Label>
              <Input
                onChange={(e) => this.handleRadioChange(e)}
                type="radio"
                name="damage"
                value="1"
                defaultChecked
              />
              <Label>{this.lang("pre-Damage")}</Label>

              <Input
                onChange={(e) => this.handleRadioChange(e)}
                value="0"
                type="radio"
                name="damage"
              />
            </ModalBody>
            <ModalFooter>
              <Button
                // disabled={this.state.extraImgRadioValue === "" ? true : false}
                color="danger"
                onClick={() => this.handleToggle(this.state.uploadPartName)}
              >
              {this.state.loading ? (
                <Spinner size="sm" color="light" />
              ) : (
                <span>{this.lang("capture")}</span>
              )}
              </Button>{" "}
              <Button color="secondary" onClick={this.toggleUploadModal}>
                {this.lang("Cancel")}
              </Button>
            </ModalFooter>
          </Modal> */}
        <Modal
          isOpen={this.state.isUploadModalOpen}
          toggle={this.toggleUploadModal}
          centered
          className="image_capture_modal_wrapper"
        >
          {/* <ModalHeader toggle={this.toggleUploadModal}>
              Choose Damage & pre-Damage Image
            </ModalHeader> */}
          <ModalBody>
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <FormGroup className="custom_input_radio">
                    <div className="d-flex align-items-center">
                      <div className="d-flex align-items-center pr-3">
                        <Input
                          onChange={(e) => this.handleRadioChange(e)}
                          type="radio"
                          name="damage"
                          value="1"
                          defaultChecked
                        />
                        <Label className="ml-2">{this.lang("Damage")}</Label>
                      </div>
                      <div className="d-flex align-items-center ml-3">
                        <Input
                          onChange={(e) => this.handleRadioChange(e)}
                          value="0"
                          type="radio"
                          name="damage"
                        />
                        <Label className="ml-2">
                          {this.lang("pre-Damage")}
                        </Label>
                      </div>
                    </div>
                  </FormGroup>
                </div>
                <div className="col-12 mt-3 pt-2 text-center">
                  <Button
                    className="btn-secondary mr-3"
                    onClick={this.toggleUploadModal}
                  >
                    {this.lang("Cancel")}
                  </Button>
                  <Button
                    className="btn-danger"
                    // disabled={this.state.extraImgRadioValue === "" ? true : false}
                    onClick={() =>
                      this.handleToggle(this.state.uploadPartName)
                    }
                  >
                    {this.state.loading ? (
                      <Spinner style={{ height: '1rem', width: '1rem' }} size="sm" color="light" />
                    ) : (
                      // <>{this.lang("capture")}</>
                      <>
                        <i className="fa fa-camera"></i>
                      </>
                    )}
                  </Button>{" "}
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        {/* Lightbox */}
        {isLightBoxOpen && (
          <Lightbox
            className="photoapp_lightbox_main"
            reactModalStyle={{
              overlay: { zIndex: 100000000 },
              content: {},
            }}
            toolbarButtons={toolbarButtons}
            imageCaption={this.lang(
              arr &&
                arr.length > 0 &&
                arr[
                  imagesModalCurrentSourceIndex
                ]
                .replace(/^Report_/, "") // Remove 'Report_' prefix
                .replace(/_\d+\.(jpg|png|jpeg)$/, "") // Remove '_<number>.<extension>' suffix
                .replace(/\.(jpg|png|jpeg)$/, "") // Remove '.<extension>' if any
            )}
            mainSrc={
              isDashboard || !isDashboard
                ? `${configuration.imagePath}/scanImages/${partnerId}/${vin}/${arr[imagesModalCurrentSourceIndex]}?${Date.now()}`
                : arr[imagesModalCurrentSourceIndex] &&
                  arr[imagesModalCurrentSourceIndex].split('.')[0] &&
                  updatedImages.hasOwnProperty(arr[imagesModalCurrentSourceIndex].split('.')[0])
                  ? `${configuration.imagePath}/scanImages/${partnerId}/${vin}/${arr[imagesModalCurrentSourceIndex]}?${updatedImages[arr[imagesModalCurrentSourceIndex].split('.')[0]]}`
                  : arr[imagesModalCurrentSourceIndex]
                    ? `${configuration.imagePath}/scanImages/${partnerId}/${vin}/${arr[imagesModalCurrentSourceIndex]}`
                    : dashboardErrorLogo
            }

            nextSrc={
              (showNextPrevButton && arr[imagesModalCurrentSourceIndex + 1]) ? `${configuration.imagePath}/scanImages/${partnerId}/${vin}/${arr[imagesModalCurrentSourceIndex + 1]}` : dashboardErrorLogo
            }

            prevSrc={
              (showNextPrevButton && arr[imagesModalCurrentSourceIndex - 1]) ? `${configuration.imagePath}/scanImages/${partnerId}/${vin}/${arr[imagesModalCurrentSourceIndex - 1]}` : dashboardErrorLogo
            }

            onCloseRequest={() =>
              this.setState({
                isLightBoxOpen: false,
              })
            }

            // onImageLoadError={(...events) => { console.log(events) }}

            onMovePrevRequest={
              () =>
                showNextPrevButton && this.setState({
                  imagesModalCurrentSourceIndex:
                    (imagesModalCurrentSourceIndex +
                      arr.length -
                      1) %
                    arr.length,
                  imageName: arr[imagesModalCurrentSourceIndex - 1] ? arr[imagesModalCurrentSourceIndex - 1].split(".")[0] : ''
                })
            }

            onMoveNextRequest={
              () =>
                showNextPrevButton && this.setState({
                  imagesModalCurrentSourceIndex:
                    (imagesModalCurrentSourceIndex + 1) %
                    arr.length,
                  imageName: arr[imagesModalCurrentSourceIndex + 1] ? arr[imagesModalCurrentSourceIndex + 1].split(".")[0] : ''
                })
            }

            imageLoadErrorMessage={
              <img
                style={{ height: "100%", width: "100%" }}
                src={require("../../../assets/img/brand/dashboard-error-logo.png")}
              />
            }
          />
        )}
        {isPreDamageImageLightBoxOpen && (
          <Lightbox
            className="photoapp_lightbox_main"
            reactModalStyle={{
              overlay: { zIndex: 100000000 },
              content: {},
            }}
            imageCaption={
              this.lang(
                preDamageImagesArr && preDamageImagesArr.length > 0 && preDamageImagesArr[imagesModalCurrentSourceIndex].split("/")[6]
                  .replace(/^svg_/, '')      // Remove 'Report_' prefix
                  .replace(/_\d+\.jpg$/, '')    // Remove '_<number>.jpg' suffix
                  .replace(/\.jpg$/, '')        // Remove '.jpg' extension if any
                  .replace(/\.jpeg$/, '')        // Remove '.jpeg' extension if any
                  .replace(/\.jpeg$/, '')        // Remove '.jpeg' extension if any
                  .replace(/\.svg$/, '')        // Remove '.svg' extension if any
                  .replace(/\.webp$/, '')        // Remove '.webp' extension if any
              )
            }
            // toolbarButtons={toolbarButtons}
            mainSrc={
              isDashboard || !isDashboard
                ? `${preDamageImagesArr[imagesModalCurrentSourceIndex]}?${Date.now()}`
                        : dashboardErrorLogo
                }

            nextSrc={
              (showNextPrevButton && preDamageImagesArr[imagesModalCurrentSourceIndex + 1]) ? `${preDamageImagesArr[imagesModalCurrentSourceIndex + 1]}` : dashboardErrorLogo
            }

            prevSrc={
              (showNextPrevButton && preDamageImagesArr[imagesModalCurrentSourceIndex - 1]) ? `${preDamageImagesArr[imagesModalCurrentSourceIndex - 1]}` : dashboardErrorLogo
            }

            onCloseRequest={() =>
              this.setState({
                isPreDamageImageLightBoxOpen: false,
              })
            }

            onImageLoadError={(...events) => { console.log(events) }}

            onMovePrevRequest={
              () =>
                showNextPrevButton && this.setState({
                  imagesModalCurrentSourceIndex:
                    (imagesModalCurrentSourceIndex +
                      preDamageImagesArr.length -
                      1) %
                    preDamageImagesArr.length,
                  imageName: preDamageImagesArr[imagesModalCurrentSourceIndex - 1] ? preDamageImagesArr[imagesModalCurrentSourceIndex - 1].split(".")[0] : ''
                })
            }

            onMoveNextRequest={
              () =>
                showNextPrevButton && this.setState({
                  imagesModalCurrentSourceIndex:
                    (imagesModalCurrentSourceIndex + 1) %
                    preDamageImagesArr.length,
                  imageName: preDamageImagesArr[imagesModalCurrentSourceIndex + 1] ? preDamageImagesArr[imagesModalCurrentSourceIndex + 1].split(".")[0] : ''
                })
            }

            imageLoadErrorMessage={
              <img
                style={{ height: "100%", width: "100%" }}
                src={require("../../../assets/img/brand/dashboard-error-logo.png")}
              />
            }
          />
        )}

      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  reportAuthorized: (show) => dispatch(reportAuthorized(show)),
});

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps,mapDispatchToProps)(PhotoApp);
